import {pxToRem} from '../../../../utills/pxToRem'
import {fonts} from '../../../../theme/foundations/fonts'

export const modalContentStyle = {
    width: pxToRem(1190),
    maxWidth: '95vw',
    minHeight: pxToRem(635),
    marginX: 'auto',
    marginTop: pxToRem(100),
    overflowY: 'auto',
    overflowX: 'hidden'
}

export const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    top: 0,
    right: pxToRem(-24)
}

export const imageGalleryStyle = {
    height: 'initial',
    padding: `${pxToRem(16)} 0`,
    '.viewer-wrap': {
        paddingBottom: pxToRem(10)
    },
    '& button[data-test="nav-next"], & button[data-test="nav-prev"]': {
        '[data-test="svg-image"]': {
            width: pxToRem(47),
            height: pxToRem(47)
        },
        '&:hover': {
            background: 'white',
            'svg path': {
                fill: 'black'
            }
        }
    },
    '& div[data-test="carousel-nav-next"], & div[data-test="carousel-nav-prev"]': {
        display: 'none'
    }
}

export const productTitle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(22),
    fontWeight: '600',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase'
}

export const productDescriptionLayout = {
    marginTop: pxToRem(40.81),
    marginLeft: pxToRem(25),
    marginRight: pxToRem(60),
    marginBottom: pxToRem(38.77)
}
